/**
 * InterpreterContext — provides interpreter mode state without prop drilling.
 * Mirrors RN's `apps/WunderGuide/context/InterpreterContext.tsx`.
 */

import { createContext, useContext, type ReactNode } from 'react';
import type { UseInterpreterModeReturn } from '../hooks/useInterpreterMode';

const InterpreterContext = createContext<UseInterpreterModeReturn | undefined>(
  undefined,
);

interface InterpreterProviderProps {
  value: UseInterpreterModeReturn;
  children: ReactNode;
}

export function InterpreterProvider({
  value,
  children,
}: InterpreterProviderProps) {
  return (
    <InterpreterContext.Provider value={value}>
      {children}
    </InterpreterContext.Provider>
  );
}

export function useInterpreter(): UseInterpreterModeReturn {
  const ctx = useContext(InterpreterContext);
  if (!ctx) {
    throw new Error(
      'useInterpreter must be used within an InterpreterProvider',
    );
  }
  return ctx;
}

export default InterpreterContext;
